import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/api-reference.md';
import Alerts from '/src/pages/documentation/resources/alerts.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "target-api-reference"
    }}>{`Target API reference`}</h1>
    <Alerts query="platform=outdated-version&componentClass=InlineNestedAlert" mdxType="Alerts" />
    <h2 {...{
      "id": "clearprefetchcache"
    }}>{`clearPrefetchCache`}</h2>
    <p>{`This API clears the in-memory cache that contains the prefetched offers.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=clear-prefetch-cache" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=clear-prefetch-cache" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=clear-prefetch-cache" mdxType="Tabs" />
    <h2 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h2>
    <p>{`Returns the running version of the Target extension.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=extension-version" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=extension-version" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=extension-version" mdxType="Tabs" />
    <h2 {...{
      "id": "getsessionid"
    }}>{`getSessionId`}</h2>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`This API is only available in Android and in `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/adobe-target/api-reference/"
      }}>{`latest iOS Target Mobile SDKs`}</a>{`.`}</p>
    <p>{`This API gets the Target session identifier. `}</p>
    <p>{`The session ID is generated locally in the SDK upon initial Target request and persisted for a period defined by `}<inlineCode parentName="p">{`target.sessionTimeout`}</inlineCode>{` configuration setting. If the session timeout happens upon a subsequent Target request, a new session ID will be generated for use in the request and persisted in the SDK.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=get-session-id" mdxType="Tabs" />
    <h2 {...{
      "id": "getthirdpartyid"
    }}>{`getThirdPartyId`}</h2>
    <p>{`This API gets the custom visitor ID for Target. If no `}<inlineCode parentName="p">{`third-party`}</inlineCode>{` ID was previously set, or if the ID was reset by calling resetExperience API, it will have a `}<inlineCode parentName="p">{`nil`}</inlineCode>{` value.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=get-third-party-id" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=get-third-party-id" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=get-third-party-id" mdxType="Tabs" />
    <h2 {...{
      "id": "gettntid"
    }}>{`getTntId`}</h2>
    <p>{`This API gets the Target user ID (also known as the `}<inlineCode parentName="p">{`tntId`}</inlineCode>{`) from the Target service. The `}<inlineCode parentName="p">{`tntId`}</inlineCode>{` is returned in the network response after a successful call to `}<inlineCode parentName="p">{`prefetchContent`}</inlineCode>{` or `}<inlineCode parentName="p">{`retrieveLocationContent`}</inlineCode>{`, which is then persisted in the SDK. This ID is preserved between app upgrades, is saved and restored during the standard application backup process, and is removed at uninstall or when the `}<inlineCode parentName="p">{`resetExperience`}</inlineCode>{` API is used.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=get-tnt-id" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=get-tnt-id" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=get-tnt-id" mdxType="Tabs" />
    <h2 {...{
      "id": "locationclicked"
    }}>{`locationClicked`}</h2>
    <p>{`This API sends a location click notification for an mbox to the configured Target server and can be invoked in the following cases:`}</p>
    <ul>
      <li parentName="ul">{`For a prefetched mbox, after the mbox content is retrieved using the `}<inlineCode parentName="li">{`retrieveLocationContent`}</inlineCode>{` API.`}</li>
      <li parentName="ul">{`For a regular mbox, where no previous prefetch request is made, and the mbox content is retrieved using the `}<inlineCode parentName="li">{`retrieveLocationContent`}</inlineCode>{` API.`}</li>
    </ul>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=location-clicked" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=location-clicked" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=location-clicked" mdxType="Tabs" />
    <h2 {...{
      "id": "locationsdisplayed"
    }}>{`locationsDisplayed`}</h2>
    <p>{`This API sends a location display notification for an mbox to the configured Target server. The API should be invoked for a prefetched mbox after the mbox content is retrieved using the `}<inlineCode parentName="p">{`retrieveLocationContent`}</inlineCode>{` API. If no previous prefetch request is made, and the mbox content is retrieved using the `}<inlineCode parentName="p">{`retrieveLocationContent`}</inlineCode>{` API, calling this API does not trigger a notification request to the Target server.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=locations-displayed" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=locations-displayed" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=locations-displayed" mdxType="Tabs" />
    <h2 {...{
      "id": "prefetchcontent"
    }}>{`prefetchContent`}</h2>
    <p>{`This API sends a prefetch request to your configured Target server. The prefetch request is sent with the prefetch objects array and the specified Target parameters.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=prefetch-content" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=prefetch-content" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=prefetch-content" mdxType="Tabs" />
    <h2 {...{
      "id": "registerextension"
    }}>{`registerExtension`}</h2>
    <p>{`Registers the Target extension with the Mobile Core.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=register-extension" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=register-extension" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=register-extension" mdxType="Tabs" />
    <h2 {...{
      "id": "resetexperience"
    }}>{`resetExperience`}</h2>
    <p>{`This API resets the user's experience by removing the visitor identifiers and resetting the Target session. Invoking this API also removes previously set Target user ID and custom visitor IDs, Target Edge Host, and the session information from persistent storage.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=reset-experience" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=reset-experience" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=reset-experience" mdxType="Tabs" />
    <h2 {...{
      "id": "retrievelocationcontent"
    }}>{`retrieveLocationContent`}</h2>
    <p>{`This API sends a batch request to the configured Target server for multiple mbox locations.`}</p>
    <p>{`A request will be sent to the configured Target server for mbox locations in the requests array for Target requests that have not been previously prefetched. The content for the mbox locations that have been prefetched in a previous request are returned from the SDK, and no additional network request is made. Each Target request object in the list contains a callback function, which is invoked when content is available for its given mbox location.`}</p>
    <p>{`When using `}<inlineCode parentName="p">{`contentWithData`}</inlineCode>{` callback to instantiate TargetRequest object, the following keys can be used to read response tokens and Analytics for Target (A4T) info from the data payload, if available in the Target response.`}</p>
    <ul>
      <li parentName="ul">{`responseTokens (Response tokens)`}</li>
      <li parentName="ul">{`analytics.payload (A4T payload)`}</li>
      <li parentName="ul">{`clickmetric.analytics.payload (Click tracking A4T payload)`}</li>
    </ul>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=retrieve-location-content" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=retrieve-location-content" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=retrieve-location-content" mdxType="Tabs" />
    <h2 {...{
      "id": "setpreviewrestartdeeplink"
    }}>{`setPreviewRestartDeepLink`}</h2>
    <p>{`This API sets a specific location in the app to be displayed when preview mode selections have been confirmed.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=set-preview-restart-deep-link" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=set-preview-restart-deep-link" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=set-preview-restart-deep-link" mdxType="Tabs" />
    <h2 {...{
      "id": "setsessionid"
    }}>{`setSessionId`}</h2>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`This API is only available in Android and in `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/adobe-target/api-reference/"
      }}>{`latest iOS Target Mobile SDKs`}</a>{`.`}</p>
    <p>{`This API sets the Target session identifier.`}</p>
    <p>{`The provided session ID is persisted in the SDK for a period defined by `}<inlineCode parentName="p">{`target.sessionTimeout`}</inlineCode>{` configuration setting. If the provided session ID is nil/null or empty, or if the privacy status is opted out, the SDK will remove the session ID value from the persistence.`}</p>
    <p>{`This ID is preserved between app upgrades, is saved and restored during the standard application backup process, and is removed at uninstall, upon privacy status update to opted out, or when the resetExperience API is used.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=set-session-id" mdxType="Tabs" />
    <h2 {...{
      "id": "setthirdpartyid"
    }}>{`setThirdPartyId`}</h2>
    <p>{`This API sets the custom visitor ID for Target. This ID is preserved between app upgrades, is saved and restored during the standard application backup process, and is removed at uninstall or when the resetExperience API is used.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=set-third-party-id" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=set-third-party-id" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=set-third-party-id" mdxType="Tabs" />
    <h2 {...{
      "id": "settntid"
    }}>{`setTntId`}</h2>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`This API is only available in Android and in `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/adobe-target/api-reference/"
      }}>{`latest iOS Target Mobile SDKs`}</a>{`.`}</p>
    <p>{`This API sets the Target user identifier.`}</p>
    <p>{`The provided tnt ID is persisted in the SDK and attached to subsequent Target requests. It is used to derive the edge host value in the SDK, which is also persisted and used in future Target requests. If the provided tnt ID is nil/null or empty, or if the privacy status is opted out, the SDK will remove the tnt ID and edge host values from the persistence.`}</p>
    <p>{`This ID is preserved between app upgrades, is saved and restored during the standard application backup process, and is removed at uninstall, upon privacy status update to opted out, or when the `}<inlineCode parentName="p">{`resetExperience`}</inlineCode>{` API is used.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=set-tnt-id" mdxType="Tabs" />
    <h2 {...{
      "id": "visual-preview"
    }}>{`Visual preview`}</h2>
    <p>{`Target visual preview mode allows you to easily perform end-to-end QA activities by enrolling and previewing these activities on your device. This mode does not require a specialized testing set up. To get started, set up a URL scheme and generate the preview links.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=visual-preview" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=visual-preview" mdxType="Tabs" />
    <h2 {...{
      "id": "public-classes"
    }}>{`Public classes`}</h2>
    <p>{`The following is a list of all the public classes available when using the Adobe Target extension.`}</p>
    <h3 {...{
      "id": "target-request"
    }}>{`Target request`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=target-request" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=target-request" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=target-request" mdxType="Tabs" />
    <h3 {...{
      "id": "target-prefetch"
    }}>{`Target prefetch`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=target-prefetch" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=target-prefetch" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=target-prefetch" mdxType="Tabs" />
    <h3 {...{
      "id": "target-parameters"
    }}>{`Target parameters`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=target-parameters" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=target-parameters" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=target-parameters" mdxType="Tabs" />
    <h3 {...{
      "id": "target-order"
    }}>{`Target order`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=target-order" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=target-order" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=target-order" mdxType="Tabs" />
    <h3 {...{
      "id": "target-product"
    }}>{`Target product`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=target-product" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=target-product" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=target-product" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      